// eslint-disable-next-line import/no-extraneous-dependencies
import qs from "query-string";
import styled from "@emotion/styled";
import { useEffect, useState, useCallback } from "react";
import { useAuth } from "../hooks/useAuth";
import spinner from "../assets/spinner.svg";
import { Color } from "../components/styles/enums";
import { Image } from "../components/ui/image";
import { Text } from "../components/ui/text";
import { AuthUseCase } from "../usecases/authUseCase";

const PageWrapper = styled.div`
  background-color: ${Color.PRIMARY};
  height: 100vh;
  vertical-align: middle;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Loading = styled.div`
  vertical-align: middle;
`;

const LoadingIndicator = styled(Image)`
  height: 40px;
  vertical-align: middle;
  padding-left: 5px;
`;

const authUseCase = new AuthUseCase();

export const LogoutContainer: React.FC = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const nextParam = urlParams.get("next");
  const [logoutStudio] = useState(nextParam === "studio");
  const studioUrl = process.env.REACT_APP_TELLER_STUDIO_DOMAIN;
  const { user } = useAuth();

  const logout = useCallback(async () => {
    await authUseCase.logout();
  }, []);

  useEffect(() => {
    const nextToStudio = logoutStudio && studioUrl;
    logout().then(() => {
      if (nextToStudio) {
        window.location.href = `//${studioUrl}/logout`;
      } else {
        window.location.href = qs.stringifyUrl({
          url: `//${process.env.REACT_APP_WEB_DOMAIN}/auth/logout`,
          query: {
            from: "/",
          },
        });
      }
    });
  }, [logout, logoutStudio, studioUrl, user]);

  return (
    <PageWrapper>
      <div>
        <Loading>
          <Text mb={10} fw="bold" color={Color.ACCENT_500}>
            読み込み中
          </Text>
          <LoadingIndicator src={spinner} />
        </Loading>
      </div>
    </PageWrapper>
  );
};
